/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  // trailers

  // AMVs
  {
    _id: "YAXTn0E-Zgo",
    title: "Grand Escape | A Weathering With You AMV",
    desc: `Thanks For Watching!
    Please Like & Subscribe!
    
    Fun Fact:
    In 1992, a shipping crate containing 28,000 rubber duckies fell overboard. They washed up around the world for the next 20 years.
    
    Song:
    Radwimps - Grand Escape feat. Toko Miura
    Movie Version:
    - https://www.youtube.com/watch?v=WwyDp...
    Original Version:
    - https://www.youtube.com/watch?v=saDmN...
    Buy:
    - https://play.google.com/music/preview...
    - https://music.apple.com/us/album/weat...
    
    Radwimps:
    - https://radwimps.jp/
    - https://myspace.com/radwimps
    - https://twitter.com/RADWIMPS
    - https://www.youtube.com/user/radwimps...
    
    Anime:
    Weathering With You / Tenki no Ko
    `,
    uploadDate: "Jun 7, 2020",
    thumbnail: {
      src: "https://img.youtube.com/vi/YAXTn0E-Zgo/0.jpg",
      alt: "Grand Escape | A Weathering With You AMV",
    },
    categoryName: "AMVs",
    creator: {
      name: "Tranquility",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQL9Z2N2MN2lfxePpKe0REi59cOrHg6H7lWPphtvg=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: true,
    newArrival: false,
  },

  {
    _id: "pBp5QxmI1kw",
    title: "【呪術廻戦】最強の2人が歌うフォニイ【声真似 / 手書き】",
    desc: `This video is a fan-made animation of Jujutsu Kaisen. 
    There are some fake scenes and spoilers of volume 8 and 9. 
    There are scenes with the same level of scars and bloodshed as the original. 
    Please refrain from posting any comment or doing anything that may cause 
    trouble for the original creator or the original manga/anime.
    
    ※Hate speech, or comments that suggest any kind  of relationship that are not 
    in the video are not allowed.
    ※Please be noted that comments considered inappropriate may be removed.
    ※No reproduction on other sites without permission. 
    
    Thank you for your comprehension.`,
    uploadDate: "Dec 23, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/pBp5QxmI1kw/0.jpg",
      alt: "【呪術廻戦】最強の2人が歌うフォニイ【声真似 / 手書き】",
    },
    categoryName: "AMVs",
    creator: {
      name: "もるでお",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLTwe6tW2Iy87eDYwibVz8usFzerV8m2rv7h7spSZQ=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "8nKJCNgiVhc",
    title: "Enemy「AMV」Anime Mix",
    desc: `Anime used:
    Akame ga kill
    Tokyo ghoul
    Tokyo ghoul Jack
    Jujitsu kaisen
    Black bullet
    Naruto 
    Charlotte
    Voilet Evergarden
    Bakemonogatari
    Attack on titan
    Demon slayer
    Chivalry of a Failed Knight
    My Hero adedemia
    Fire Force:
    One punch man
    One piece
    Mushoku tensei 
    Boruto 
    Bleach 
    Fate/stay night: Heaven's Feel III 
    Mob phycho 100 
    Garo: Honoo no Kokuin
    Bungo Stray Dogs
    Dragon Ball Super: Broly
    Koutetsujou no Kabaneri
    Tengen Toppa Gurren Lagann
    Sword art online 
    Afro Samurai 
    Fate/zero 
    Tales of arise 
    Fate/stay night unlimited blade works`,
    uploadDate: "Jan 5, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/8nKJCNgiVhc/0.jpg",
      alt: "Enemy「AMV」Anime Mix",
    },
    categoryName: "AMVs",
    creator: {
      name: "Tumpy GFX",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLR8oRzpmYWgk9mJDKnVf7TFbYoKpspKUmvdDk0J8g=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: true,
    newArrival: false,
  },

  {
    _id: "cP-IcDUp7pU",
    title: "It's Just An Anime",
    desc: `Anime Used:
    1Weathering with you
    2.Your Name
    3.A Silent Voice
    4.Charlotte
    5.Death Note
    6.Mob Psycho 100
    7.Hello World
    8.Demon Slayer
    9.Violet Evergarden
    10.A Spirited Away
    11.Akira
    12.A Whisker Away
    13.FMAB
    14.Code Geass
    15.Darling in the Franx
    16.High School of the Dead 
    17.Cowboy Bebop
    18.Naruto
    19.Attack On Titan`,
    uploadDate: "May 31, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/cP-IcDUp7pU/0.jpg",
      alt: "It's Just An Anime",
    },
    categoryName: "AMVs",
    creator: {
      name: "VENOM AMV",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRwZrawAZvTAcGsJRJqMknZNRw3P2SaoIM7xwXX=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  // reviews
  {
    _id: "6XbGyJeDWWI",
    title: "Dress-Up Darling Gave Us The Perfect Girl",
    desc: ``,
    uploadDate: "Mar 20, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/6XbGyJeDWWI/0.jpg",
      alt: "Dress-Up Darling Gave Us The Perfect Girl",
    },
    categoryName: "Reviews",
    creator: {
      name: "Gigguk",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRb76Qettp7l4j-22D7WrAsBT1G1Cc9KpRNm2pm=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: true,
  },

  {
    _id: "A_9gR41ivBU",
    title: "Demon Slayer just Set a New Standard",
    desc: ``,
    uploadDate: "Mar 5, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/A_9gR41ivBU/0.jpg",
      alt: "Demon Slayer just Set a New Standard",
    },
    categoryName: "Reviews",
    creator: {
      name: "Gigguk",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRb76Qettp7l4j-22D7WrAsBT1G1Cc9KpRNm2pm=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "bWkCkGYyxIs",
    title: "Solo Leveling Is The Power Fantasy We Needed",
    desc: ``,
    uploadDate: "Nov 18, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/bWkCkGYyxIs/0.jpg",
      alt: "Solo Leveling Is The Power Fantasy We Needed",
    },
    categoryName: "Reviews",
    creator: {
      name: "Gigguk",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRb76Qettp7l4j-22D7WrAsBT1G1Cc9KpRNm2pm=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "1qk1BoGRM7c",
    title: "Stop Sleeping on Vinland Saga.",
    desc: ``,
    uploadDate: "Sep 19, 2019",
    thumbnail: {
      src: "https://img.youtube.com/vi/1qk1BoGRM7c/0.jpg",
      alt: "Stop Sleeping on Vinland Saga.",
    },
    categoryName: "Reviews",
    creator: {
      name: "Gigguk",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRb76Qettp7l4j-22D7WrAsBT1G1Cc9KpRNm2pm=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  // top 10 series
  {
    _id: "ZBGUYy8CZBQ",
    title: "Top 10 Best High School/Romance Anime That You Might Have Missed",
    desc: `Welcome weebs, today we're going back to the good old highschool drama. I know I did a video about ten highschool romance anime before, 
    but in this list we're going to go over some new ones you might not have heard of. So strap in your tsundere belts, 
    and get ready to get slapped in the faces. Here are ten high school romance anime you must watch.`,
    uploadDate: "Mar 12, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/ZBGUYy8CZBQ/0.jpg",
      alt: "Top 10 Best High School/Romance Anime That You Might Have Missed",
    },
    categoryName: "Top 10 Series",
    creator: {
      name: "Otaku Den",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLSa3mPjAt2s-xRYcvGDwXNwvN9NVY_e4wzcy3eoJw=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "qjWmwnXNFOQ",
    title: "Top 10 Anime With A Dark/Overpowered/Badass Main Character!",
    desc: ``,
    uploadDate: "Dec 5, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/qjWmwnXNFOQ/0.jpg",
      alt: "Top 10 Anime With A Dark/Overpowered/Badass Main Character!",
    },
    categoryName: "Top 10 Series",
    creator: {
      name: "Anime Sensei",
      avatar:
        "https://yt3.ggpht.com/Nr5HJqQsseTNSY3RUh78UKYNKVQZ43cmELSorrGMACs_apxX9VXJvT6WvARoXLEgUPhTGV87=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "Bw0qkaVLa0o",
    title:
      "10 Isekai Fantasy Anime Where Main Character Gets Transferred to Another World With Strong Power",
    desc: `Isekai is that genre of anime and manga where characters are transported to another world, 
    the events in these series take place in an alternate world and it makes for a great spectacle. Most of these anime belong to the fantasy genre and a lot of them are set in a game world so we get to see the main characters using a levelling up system to upgrade their abilities. There is a mysterious feeling to a character randomly finding his or herself in a new world, it opens up a lot of possibilities. Watching these characters develop,
     trying to survive and going on to conquer and dominate this parallel world is something that brings satisfaction to the anime community.`,
    uploadDate: "Mar 2, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/Bw0qkaVLa0o/0.jpg",
      alt: "10 Isekai Fantasy Anime Where Main Character Gets Transferred to Another World With Strong Power",
    },
    categoryName: "Top 10 Series",
    creator: {
      name: "Anime Sensei",
      avatar:
        "https://yt3.ggpht.com/Nr5HJqQsseTNSY3RUh78UKYNKVQZ43cmELSorrGMACs_apxX9VXJvT6WvARoXLEgUPhTGV87=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "1Z5gPszM8BU",
    title: "Top 10 Anime Where The OP/Badass/Smart MC Surprises Everyone!",
    desc: ``,
    uploadDate: "Mar 10, 2022",
    thumbnail: {
      src: "https://img.youtube.com/vi/1Z5gPszM8BU/0.jpg",
      alt: "Top 10 Anime Where The OP/Badass/Smart MC Surprises Everyone!",
    },
    categoryName: "Top 10 Series",
    creator: {
      name: "Anime Sensei",
      avatar:
        "https://yt3.ggpht.com/Nr5HJqQsseTNSY3RUh78UKYNKVQZ43cmELSorrGMACs_apxX9VXJvT6WvARoXLEgUPhTGV87=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  // analysis

  {
    _id: "A6zybSnplFc",
    title: "The Masterpiece of Clannad After Story",
    desc: `Kaze talks about why he thinks Clannad After Story is a masterpiece.

    If you enjoyed the video, please hit that like button :)`,
    uploadDate: "Feb 12, 2019",
    thumbnail: {
      src: "https://img.youtube.com/vi/A6zybSnplFc/0.jpg",
      alt: "The Masterpiece of Clannad After Story",
    },
    categoryName: "Analysis",
    creator: {
      name: "Kaze Talks",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRPluRvz1Rg0CaLQnyxrCF7GZaHSCf-bs_oNYabgA=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "H3Zha69GSE4",
    title:
      "Sacrifice & The Cost of Freedom - Attack on Titan (A Thematic Analysis)",
    desc: `With the Final Season of Attack on Titan airing right now, I thought it would be a good idea to revisit Season 3 and analyse what made it so profoundly captivating. 
    Today I take a thematic look at Attack on Titan and how it tackles the ideas of sacrifice and freedom. `,
    uploadDate: "Jan 18, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/H3Zha69GSE4/0.jpg",
      alt: "Sacrifice & The Cost of Freedom - Attack on Titan (A Thematic Analysis)",
    },
    categoryName: "Analysis",
    creator: {
      name: "Kevin Nyaa",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQfuchcyEgNG71zGR7ZfX6FZrn3qoDJMi-exc6i=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "n4ascZKKQtE",
    title: "How A Silent Voice Saved Me - The Perfect Anime Film",
    desc: `A Silent Voice is more than just my favourite anime film, it's my favourite film of all time. 
    It presents the core messages of anxiety, depression and self-hatred and how you can learn to overcome it. 
    A Silent Voice is a film that I've always wanted to talk about but never had the courage to because I was afraid of not giving the film the justice it deserves. 
    However, today I finally take that step forward and talk about A Silent Voice and how much it means to me. I hope you enjoy.`,
    uploadDate: "May 16, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/n4ascZKKQtE/0.jpg",
      alt: "How A Silent Voice Saved Me - The Perfect Anime Film",
    },
    categoryName: "Analysis",
    creator: {
      name: "Kevin Nyaa",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQfuchcyEgNG71zGR7ZfX6FZrn3qoDJMi-exc6i=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "umb8WwJ5J1o",
    title: "How Violet Evergarden Crafted An Emotional Masterpiece",
    desc: `After rewatching Violet Evergarden, I've discovered a new found appreciation for the series that I hadn't felt before. Beyond the beautiful and elegant presentation, Violet Evergarden is a story about how a person can learn to understand the many facets of human emotion and how it can change ones life forever. 
    Today I want to show everyone, especially to those who couldn’t get into the series, How Violet Evergarden Crafted An Emotional Masterpiece.`,
    uploadDate: "Aug 29, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/umb8WwJ5J1o/0.jpg",
      alt: "How Violet Evergarden Crafted An Emotional Masterpiece",
    },
    categoryName: "Analysis",
    creator: {
      name: "Kevin Nyaa",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQfuchcyEgNG71zGR7ZfX6FZrn3qoDJMi-exc6i=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "EI2--1imsXk",
    title: "Kyoto Animation Changed My Life",
    desc: `Kyoto Animation changed my life and I can ever be so appreciative.`,
    uploadDate: "Jul 26, 2019",
    thumbnail: {
      src: "https://img.youtube.com/vi/EI2--1imsXk/0.jpg",
      alt: "Kyoto Animation Changed My Life",
    },
    categoryName: "Analysis",
    creator: {
      name: "Kevin Nyaa",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQfuchcyEgNG71zGR7ZfX6FZrn3qoDJMi-exc6i=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: false,
    newArrival: false,
  },

  // Jpop

  {
    _id: "VzS2yriuQFs",
    title:
      "真夜中のドア (Stay With Me) - 松原みき (Miki Matsubara) | Cover by Chris Andrian Yang",
    desc: `This was highly requested on tiktok so here you go! I love this song so much but yooo the lyrics are so sad :(`,
    uploadDate: "Feb 5, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/VzS2yriuQFs/0.jpg",
      alt: "真夜中のドア (Stay With Me) - 松原みき (Miki Matsubara) | Cover by Chris Andrian Yang",
    },
    categoryName: "J-POP",
    creator: {
      name: "Chris Andrian",
      avatar:
        "https://yt3.ggpht.com/ofei-RD-A_ZiDuPH3SsCtrNX9w8tX7xAE-7uzYDCWiW61hAy0asq74zPXm__dDCdb9a6DeES5qE=s88-c-k-c0x00ffffff-no-nd-rj",
    },
    popular: true,
    newArrival: false,
  },

  {
    _id: "8iuLXODzL04",
    title: `YOASOBI "Probably" Official Music Video`,
    desc: ``,
    uploadDate: "Jul 20, 2020",
    thumbnail: {
      src: "https://img.youtube.com/vi/8iuLXODzL04/0.jpg",
      alt: `YOASOBI "Probably" Official Music Video`,
    },
    categoryName: "J-POP",
    creator: {
      name: "Ayase / YOASOBI",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQlab7SciC0zKOTNvVomQGmkQpZIr8yRarFZ4HtZw=s88-c-k-c0x00ffffff-no-rj-mo",
    },
    popular: true,
    newArrival: false,
  },

  {
    _id: "g8ENtHe2hMU",
    title: `好きだから (feat.れん)/ 『ユイカ』【MV】`,
    desc: ``,
    uploadDate: "Oct 24, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/g8ENtHe2hMU/0.jpg",
      alt: `好きだから (feat.れん)/ 『ユイカ』【MV】`,
    },
    categoryName: "J-POP",
    creator: {
      name: "『ユイカ』",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLRfU8RPno0ghmUSnV8EC91Ygx7yXSucIpb3J1i8ww=s88-c-k-c0x00ffffff-no-rj-mo",
    },
    popular: false,
    newArrival: false,
  },

  {
    _id: "NyUTYwZe_l4",
    title: `YOASOBI - Gunjo / THE FIRST TAKE`,
    desc: `THE FIRST TAKE is a YouTube Channel dedicated to shooting musicians and singers performing in a single take.
    ONE TAKE ONLY, ONE LIFE ONLY.
    
    YOASOBI returns from THE HOME TAKE in our episode 96. The first time to have both Ayase and ikura to appear at THE FIRST TAKE.
    1 TAKE performance of “Gunjo”, a song inspired by a smash-hit anime Blue Period and has a tie-in to Bourbon Alfort Mini Chocolate TV commercial, for the first time on a media.
    Welcoming PLUSONICA as the chorus and with the band members, performs a mind blowing performance for THE FIRST TAKE.`,
    uploadDate: "Feb 26, 2021",
    thumbnail: {
      src: "https://img.youtube.com/vi/NyUTYwZe_l4/0.jpg",
      alt: `YOASOBI - Gunjo / THE FIRST TAKE`,
    },
    categoryName: "J-POP",
    creator: {
      name: "THE FIRST TAKE",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQbuBH5d26HSVtEaMt9oBgpC2G9gp5Gj3-sDgtvvA=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: true,
    newArrival: false,
  },

  {
    _id: "MpYy6wwqxoo",
    title: `LiSA - Gurenge (紅蓮華) / THE FIRST TAKE`,
    desc: `Our 5th episode features LiSA, a popular singer who is well-loved in both anisong and rock circles,
    and who will make her first appearance at NHK's Kouhaku Uta-gassen (one of Japan's most prestigious year-end music programs) this year.
    
    She will sing a special piano rendition of her 2019 hit song, ""Gurenge (紅蓮華),""
    which was the opening theme song for the popular TV anime series, ""Kimetsu no Yaiba.""A microphone and a white studio.
    And 1 rule.
    
    You’ve got 1 TAKE.
    Perform anything you like.
    
    Show us everything you’ve got for that 1 moment.`,
    uploadDate: "Dec 6, 2019",
    thumbnail: {
      src: "https://img.youtube.com/vi/MpYy6wwqxoo/0.jpg",
      alt: `LiSA - Gurenge (紅蓮華) / THE FIRST TAKE`,
    },
    categoryName: "J-POP",
    creator: {
      name: "THE FIRST TAKE",
      avatar:
        "https://yt3.ggpht.com/ytc/AKedOLQbuBH5d26HSVtEaMt9oBgpC2G9gp5Gj3-sDgtvvA=s88-c-k-c0x00ffffff-no-rj",
    },
    popular: true,
    newArrival: false,
  },
];
